export default __webpack_public_path__ + "static/Pace_350_Video-e28325c0d975e66899b1e02c5f1154a8.mp4";